import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { IMAGE } from "common-import/constants";
import { inject, observer } from "mobx-react"
import { VarHelper } from "common-import/helpers";
import { Loading } from "common-import/custom";


@inject("userStore") @observer
class UserList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isLoading: true,
    };
    this.search = this.search.bind(this);
  }

  async componentDidMount() {
    this.setState({isLoading: true});
    await this.props.userStore.onReady();
    await this.getList(this.state.page);
    this.setState({isLoading: false});
  }

  getList = async page => {
    const res = await this.props.userStore.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "page": page,
    });
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
  };

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    this.setState({ page: this.state.page === 1 ? 1 : this.state.page - 1}, () => {
      this.getList(this.state.page);
    });
  };

  loadNext = e => {
    !!e && e.preventDefault();
    this.setState({ page: this.state.page + 1}, () => {
      this.getList(this.state.page);
    });
  };

  search = (e) => {
    e.preventDefault();
  };

  renderRow = (data, index) => {
    return (
      <tr key={"listuser" + index}>
        <td className="text-center">
          <div className="avatar">
            <img src={!!data.avatar ? VarHelper.img(data.avatar) : IMAGE} className="img-avatar" alt="" />
            {/*<span className="avatar-status badge-success"> </span>*/}
          </div>
        </td>
        <td>
          <Link to={`/user/${data.id}`}>
            <div>{data.name}</div>
            <div className="small text-muted">
              <span>Email</span>: {data.email}
            </div>
            <div className="small text-muted">
              <span>Phone</span>: {data.tel}
            </div>
          </Link>
        </td>
        <td><span>{data.activated ? 'Yes' : 'No'}</span></td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <span>{data.accountStatus}</span>
            </div>
          </div>
        </td>
        <td>
          <span>{data.isAdmin ? "Yes" : "No"}</span>
        </td>

        <td>
          <div className="clearfix">
            <div className="float-left">
              <span className="small muted">{moment(data.createdAt).format('LL')}</span>
            </div>
          </div>
        </td>
      </tr>

    )
  };

  render() {
    if (this.state.isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button onClick={this.search} type="button" color="primary"><i className="fa fa-search"> </i> Search</Button>
                </InputGroupAddon>
                <Input type="text" id="input1-group2" name="input1-group2" placeholder="Username"/>
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th className="text-center"><i className="icon-people"> </i></th>
                  <th>User</th>
                  <th>Activated</th>
                  <th>Type of Account</th>
                  <th>Supper Admin</th>
                  <th>Created at</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: 'white' }}>
                {this.props.userStore.listUser.slice().map((val, index) => this.renderRow({
                  name: val.name,
                  email: val.email,
                  tel: val.phone,
                  activated: val.actived,
                  type: !!val.type ? val.type[0] : '',
                  isAdmin: val.isSuperAdmin || false,
                  avatar: val.avatar,
                  id: val.id,
                  createdAt: val.createdAt,
                  accountStatus: val.accountStatus,
                }, index))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev} />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/views/Users/List.js